import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
const proofs = ['Sofía C. de Heredia compró MegaPack + Docente Memorable 🏆 hace 3 minutos', 'Roberto M. de Alajuela compró MegaPack 📘 hace 12 minutos', 'Mariela G. de San José compró MegaPack + Docente Memorable 🏆 hace 25 minutos', 'Laura P. de Heredia compró MegaPack 📘 hace 42 minutos'];
export function SocialProofToast() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    // Initial delay before first toast
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    // Auto hide after 5 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [isVisible, isDismissed]);
  useEffect(() => {
    if (isDismissed) return;
    if (isVisible) return; // Don't rotate while visible
    // Wait 15 seconds before showing next
    const nextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % proofs.length);
      setIsVisible(true);
    }, 15000);
    return () => clearTimeout(nextTimer);
  }, [isVisible, isDismissed]);
  if (isDismissed) return null;
  return <AnimatePresence data-id="element-290">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-white rounded-lg shadow-xl border border-stone-200 p-4 pr-10 flex items-start gap-3" data-id="element-291">
          <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-292" />
          <div data-id="element-293">
            <p className="text-xs font-bold text-stone-500 uppercase tracking-wider mb-1" data-id="element-294">
              Compra verificada
            </p>
            <p className="text-sm text-stone-800 font-medium leading-tight" data-id="element-295">
              {proofs[currentIndex]}
            </p>
          </div>
          <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-stone-400 hover:text-stone-600 p-1" aria-label="Cerrar notificación" data-id="element-296">
            <X className="w-4 h-4" data-id="element-297" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}